<!-- for larger screen sized -->
<div class="header-container">

  <!-- Normal Expedition -->
  <div *ngIf="!isStudentTeamPlay" class="container">
    <div class="w-100 d-flex align-items-center justify-content-between">
      <!-- header nav items -->
      <div class="w-75 d-flex align-items-center">
        <div class="text-center py-4" [ngClass]="{'none-events':!this.isUserLoggedIn}">
          <img class="cursor-pointer" (click)="goToHome()" height="50" src="./assets/images/Global-logo.png" alt="">
        </div>
        <div class="d-none d-lg-block">
          <ul class="text-14-500-171 text-c2 nav-custom pl-3 mb-0">
            <!-- <li class="cursor-pointer" (click)="headerClicked('HOME')">
              {{'HOME' | translate}}
            </li> -->
            <li class="cursor-pointer" (click)="headerClicked('ABOUT US')">
              {{'About us' | translate}}
            </li>

            <!-- <li class="cursor-pointer"  (click)="headerClicked('Global Challenge')">
              {{'Global challenge' | translate}}
            </li> -->

            <li class="cursor-pointer" (click)="headerClicked('CONTACT')">
              {{"Contact" | translate}}
            </li>
          </ul>
        </div>
        <!-- watch video btn -->
        <a *ngIf="showWatchViewBtn" [routerLink]="navObject.link" routerLinkActive="router-link-active"
          (click)="showDialog = false" class="d-none d-lg-flex cursor-pointer pl-14 align-items-center">
          <img class="pe-3" [src]="navObject.icon" alt="play_svg">
          <span class="text-18-500-150 text-c3">{{navObject.text | translate}}</span>
        </a>
      </div>

      <!-- language select & login info -->
      <div class="position-relative d-flex align-items-center gap-4">
        <!-- section of lanuage choose -->
        <div class="d-flex align-items-center">

          <mat-select (selectionChange)="setLang(selectedLanguage)" [(value)]="selectedLanguage"
            style="width: 65px;border: 1px solid #E7DCDA; padding: 5px; border-radius: 5px;">
            <mat-option *ngFor="let lang of langOptions" [value]="lang.val">{{lang.lan}}</mat-option>
          </mat-select>
        </div>
        <!-- user Image -->
        <div *ngIf="isUserLoggedIn" (click)="toggleDialog()" class="user-image-container cursor-pointer">
          <span class="text-15-600-121">{{userDetails?.name?.charAt(0)?.toUpperCase()}}</span>
        </div>
        <div [ngClass]="{'open-dialog': showDialog}" class="logout-dialog-box">
          <div class="w-100 d-flex justify-content-between flex-column gap-4">
            <div class="d-flex ">
              <div style="width: 110px;" class="text-c2 text-14-400-157">{{'Name' | translate}}</div>
              <div class="text-c4 text-14-500-142">{{userDetails?.name || '-'}}</div>
            </div>
            <div class="d-flex text-c4 ">
              <div style="width: 110px;" class="text-c2 text-14-400-157">{{'Username' | translate}}</div>
              <div class="text-c4 text-14-500-142">{{userDetails?.username || '-'}}</div>
            </div>
          </div>
          <div (click)="logOut()"
            class="border-top mt-3 pt-2 d-flex justify-content-center gap-3 align-items-center cursor-pointer">
            <span class="text-14-500-135 text-c3">{{'Sign out'| translate}}</span>
            <img src="assets/icons/logout.svg" alt="">
          </div>
        </div>
        <!-- hamburger for toggle -->
        <div class="d-block d-lg-none float-right pointer-cursor" (click)="headerToggle()">
          <img src="assets/icons/menu.svg" alt="">
          <!-- <mat-icon class="ml-3">reorder</mat-icon> -->
        </div>
      </div>
    </div>
  </div>

  <!-- Student team play -->
  <div *ngIf="isStudentTeamPlay" class="container px-5 w-100 d-flex align-items-center justify-content-between">
    <!-- header nav items -->
    <div class="w-75 d-flex align-items-center">
      <div class="text-center py-4">
        <img height="50" src="./assets/images/Global-logo.png" alt="">
      </div>
    </div>

    <div class="position-relative d-flex align-items-center gap-4">
      <!-- section of lanuage choose -->
      <div class="d-flex align-items-center">
        <mat-select (selectionChange)="setLang(selectedLanguage)" [(value)]="selectedLanguage"
          style="width: 65px;border: 1px solid #E7DCDA; padding: 5px; border-radius: 5px;">
          <mat-option *ngFor="let lang of langOptions" [value]="lang.val">{{lang.lan}}</mat-option>
        </mat-select>
      </div>
    </div>
  </div>
</div>




<!-- for other screen sizes -->
<div class="mobileviewHeader d-block d-lg-none" *ngIf="blnMobSidebar && !isStudentTeamPlay">
  <div class="w-100 text-28-500-142 d-flex flex-column gap-4">
    <p (click)="headerClicked('ABOUT US')">{{'About us'|translate}}</p>
    <p (click)="headerClicked('Watch videos')">{{'Watch videos'|translate}}</p>
    <p *ngIf="userDetails && userDetails?.role == 1" (click)="blnMobSidebar = false;" routerLink="/map-view">
      {{'Play expedition'|translate}}</p>
    <!-- <p (click)="headerClicked('Global Challenge')">{{'Global challenge'|translate}}</p> -->
    <p (click)="headerClicked('CONTACT')">{{'Contact'|translate}}</p>
  </div>

</div>